import { Theme } from '@mui/material/styles';
import { teal } from './themePrimitives';

/**
 * Gets the icon color based on the current theme mode.
 * Returns primary color for light mode, teal for dark mode.
 * 
 * @param theme - The MUI theme object
 * @returns The appropriate color string for icons
 */
export function getIconColor(theme: Theme): string {
  return theme.palette.mode === 'light' ? theme.palette.primary.main : teal[500];
}

/**
 * Gets the icon hover color based on the current theme mode.
 * Returns primary dark for light mode, teal dark for dark mode.
 * 
 * @param theme - The MUI theme object
 * @returns The appropriate hover color string for icons
 */
export function getIconHoverColor(theme: Theme): string {
  return theme.palette.mode === 'light' ? theme.palette.primary.dark : teal[700];
}

/**
 * Gets the icon light color (for backgrounds) based on the current theme mode.
 * Returns primary light for light mode, teal light for dark mode.
 * 
 * @param theme - The MUI theme object
 * @returns The appropriate light color string for icon backgrounds
 */
export function getIconLightColor(theme: Theme): string {
  return theme.palette.mode === 'light' ? theme.palette.primary.light : teal[400];
}

/**
 * Gets the button background color based on the current theme mode.
 * Returns primary main for light mode, teal main for dark mode.
 * 
 * @param theme - The MUI theme object
 * @returns The appropriate background color string for buttons
 */
export function getButtonColor(theme: Theme): string {
  return theme.palette.mode === 'light' ? theme.palette.primary.main : teal[500];
}

/**
 * Gets the button hover background color based on the current theme mode.
 * Returns primary dark for light mode, teal dark for dark mode.
 * 
 * @param theme - The MUI theme object
 * @returns The appropriate hover background color string for buttons
 */
export function getButtonHoverColor(theme: Theme): string {
  return theme.palette.mode === 'light' ? theme.palette.primary.dark : teal[700];
}

/**
 * Gets the incoming message background color based on the current theme mode.
 * Returns gray for light mode, gray for dark mode to distinguish from primary/teal.
 * 
 * @param theme - The MUI theme object
 * @returns The appropriate background color string for incoming messages
 */
export function getIncomingMessageColor(theme: Theme): string {
  return theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[700];
}

/**
 * Gets the incoming message text color based on the current theme mode.
 * Returns dark gray text for light mode, white for dark mode.
 * 
 * @param theme - The MUI theme object
 * @returns The appropriate text color string for incoming messages
 */
export function getIncomingMessageTextColor(theme: Theme): string {
  return theme.palette.mode === 'light' ? theme.palette.text.primary : '#ffffff';
}

